export function cacheInfo(cookieName, value) {
  if (value) {
    localStorage.setItem(cookieName, value)
  }
  return localStorage.getItem(cookieName) || ""
}